import React from "react";
import BurgerButton from "../uniques/BurgerButton";

function BarNavMobile() {
  return (
    <>
      <BurgerButton isOpen={false} />
    </>
  );
}

export default BarNavMobile;
